import { Routes } from '@angular/router';
import { authGuard } from './core/auth.guard';
import { LoginComponent } from './pages/login.component';
import { ShellComponent } from './pages/shell.component';
import { DashboardComponent } from './pages/dashboard.component';
import { ListPageComponent } from './pages/list-page.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'inspecciones', component: ListPageComponent, data: { resource: 'inspecciones', title: 'Inspecciones' } },
      { path: 'mantenimientos', component: ListPageComponent, data: { resource: 'mantenimientos', title: 'Mantenimientos' } },
      { path: 'fallas', component: ListPageComponent, data: { resource: 'fallas', title: 'Reportes de falla' } },
      { path: 'activos', component: ListPageComponent, data: { resource: 'activos', title: 'Activos' } },
      { path: 'pqrs', component: ListPageComponent, data: { resource: 'pqrs', title: 'PQRS' } },
      { path: 'vehiculos', component: ListPageComponent, data: { resource: 'vehiculos', title: 'Vehiculos' } },
      { path: 'checklists', component: ListPageComponent, data: { resource: 'checklists', title: 'Checklists' } },
      { path: 'bpm-personal', component: ListPageComponent, data: { resource: 'bpm-personal', title: 'Chequeo BPM Personal' } },
      { path: 'chequeos-bpm-personal', component: ListPageComponent, data: { resource: 'chequeos-bpm-personal', title: 'Historial BPM Personal' } },
      { path: 'tipos-bpm-personal', component: ListPageComponent, data: { resource: 'tipos-bpm-personal', title: 'Tipos BPM Personal' } },
      { path: 'control-proceso', component: ListPageComponent, data: { resource: 'control-proceso', title: 'Control de proceso' } },
      { path: 'programas', component: ListPageComponent, data: { resource: 'programas', title: 'Programas PDF' } },
      { path: 'empresas', component: ListPageComponent, data: { resource: 'empresas', title: 'Empresas' } },
      { path: 'sectores', component: ListPageComponent, data: { resource: 'sectores', title: 'Sectores' } },
      { path: 'usuarios', component: ListPageComponent, data: { resource: 'usuarios', title: 'Usuarios' } }
    ]
  },
  { path: '**', redirectTo: 'dashboard' }
];
